<template>
  <div v-if="pageLoadging" class="root">
    <Detail v-if="fieldInfo" :info="fieldInfo" />
    <div class="root-main" id="root-main">
      <div class="root-main-list">
        <div class="scroll-tabs">
          <DuTabs
            :value="JSON.stringify(current)"
            @update:value="handleChangeCurrent"
            color="secondary"
          >
            <DuTab
              v-for="tab of filter"
              :name="JSON.stringify(tab)"
              :key="tab.sortType"
            >
              {{ tab.label }}
            </DuTab>
          </DuTabs>
        </div>

        <div v-if="auctions?.length" class="auctions">
          <Item
            v-for="(auctionItem, index) in auctions"
            :key="auctionItem?.auction_id"
            :auction="auctionItem"
            :currentTab="currentTab"
            :ubtName="ubtName"
            :isShowField="false"
            :isShowType="isShowType"
            :ubtIndex="index"
          />
        </div>
        <DuEmpty v-else-if="listLoaded" text="暂无相关拍品" />

        <!-- @item-tap="handleItemTap(auctionItem)" -->
      </div>
    </div>
  </div>
</template>

<script setup>
import { DuTabs, DuTab, DuEmpty } from "dangoui";

import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import AuctionApi from "@/apis/auction";
import Detail from "./components/detail.vue";
import Item from "./components/item.vue";
import { showToast, showLoadingToast, closeToast } from "vant";
import debounce from "lodash/debounce";
const route = useRoute();

const auctions = ref([]);
const fieldInfo = ref(null);
const title = ref(null);
const filter = ref(null);
const current = ref(null);
const loadStatus = ref("");
const pageLoadging = ref(false);
// 首次列表请求完成前不渲染空态，避免闪「暂无相关拍品」
const listLoaded = ref(false);
let loading = false;
onMounted(async () => {
  if (route.query.fieldId) {
    await getField();
    // 拍场信息回来先展示头部；列表直接调原始函数，不走防抖（防抖版本首次调用不会真正等待请求）
    pageLoadging.value = true;
    await getRawAuctionList();

    window.onscroll = async () => {
      const clientHeight = document.body.clientHeight;
      const y = window.scrollY;
      const contentHeight = document.getElementById("root-main").clientHeight;
      // 触底拉新
      if (y + clientHeight + 100 >= contentHeight) {
        if (loading) {
          return;
        }
        loading = true;
        await getAuctionList(true);
        loading = false;
      }
    };
  }
});

const getAuctionList = debounce(getRawAuctionList, 300);

async function getField() {
  try {
    const { data } = await AuctionApi.getFieldDetail({
      id: route.query.fieldId,
    });
    fieldInfo.value = data?.fieldInfo;
    title.value = data?.fieldInfo.fieldName;
    filter.value = data.sorts;
    current.value = data.sorts[0];
  } catch (error) {
    showToast(error?.message || error);
  }
}
async function handleChangeCurrent(e) {
  current.value = JSON.parse(e);
  await getAuctionList();
}
async function getRawAuctionList(isMore = false) {
  if (!isMore) {
    auctions.value = [];
    listLoaded.value = false;
  }
  showLoadingToast({
    message: "加载中...",
    forbidClick: true,
  });
  const offset = isMore ? auctions.value.length : 0;
  const query = {
    limit: 20,
    offset: offset,
    fieldId: route.query.fieldId,
    sort: current.value?.sortType,
    showBlindAuction: true,
    cursor:
      isMore && auctions.value?.length
        ? auctions.value[auctions.value.length - 1].lastBidTime
        : "0",
  };
  try {
    const { data } = await AuctionApi.getFieldAuctions(query);
    const list = data.items || [];
    auctions.value = isMore ? auctions.value.concat(list) : list;
    loadStatus.value =
      data.items && auctions.value.length < data.count ? "more" : "noMore";
  } finally {
    closeToast();
    listLoaded.value = true;
  }
}
</script>

<style lang="scss">
.root {
  position: relative;
  background: url(https://public.qiandaocdn.com/interior/images/72f66242404181419701de46d1394bb2.jpg)
    no-repeat top;
  background-size: 100% 812px;
  min-height: 100vh;
  .scroll-tabs {
    .du-tabs__list {
      /* 隐藏垂直滚动条 */
      &::-webkit-scrollbar {
        width: 0;
      }

      /* 隐藏水平滚动条 */
      &::-webkit-scrollbar {
        height: 0;
      }
      width: 100vw;
      overflow-x: scroll;
    }
    overflow-x: scroll;
  }
  .navbar {
    gap: 10rpx;
    height: 100%;
    .otext {
      display: flex;
      flex: 1;
      align-items: center;
      width: 0;

      color: var(--c-neutral-9);
      font-weight: 500;
      font-size: 34rpx;
      line-height: 64rpx;
    }
  }
  .scroll-tabs {
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 9;
  }
  &-main {
    position: absolute;

    width: 100%;
    min-height: 100vh;
    .du-empty {
      height: 0;
      flex: 1;
    }
    &-list {
      min-height: 100vh;
      padding-bottom: env(safe-area-inset-bottom);

      background: #fff;
    }
    &::before {
      display: block;
      width: 100%;
      height: 16rpx;

      background: #fff;
      border-radius: 24rpx 24rpx 0 0;

      content: "";
    }
    .auctions {
      padding: 20rpx 24rpx;
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      justify-content: space-between;
      gap: 16rpx;
    }
  }
}
</style>
